import axios from 'axios';
import { getPortalSettings } from './portalSettings';
import { getStateQuoteConfig } from './StateQuoteConfig';
import { successResponseInterceptor, errorResponseInterceptor } from '../infrastructure/global';

/**
 * Fetch Qualitas default annual mileage for garaging zip (PPA d2c/Mileage/ByZip).
 * Returns null when mileage is not required for the state (TX) or lookup fails.
 */
export async function fetchDefaultAnnualMileageByZip(
    stateCode: string | null | undefined,
    zipCode: string | null | undefined,
    country: string = 'USA'
): Promise<string | null> {
    const cfg = getStateQuoteConfig(stateCode);
    if (!cfg?.requireAnnualMileage) return null;

    const zip = (zipCode || '').replace(/\D/g, '').slice(0, 5);
    if (!/^\d{5}$/.test(zip)) return null;

    try {
        const ppa = axios.create({
            baseURL: getPortalSettings().apiHostUrl,
            method: 'get'
        });
        ppa.interceptors.response.use(successResponseInterceptor, errorResponseInterceptor);

        const res = await ppa.request({
            url: '/d2c/Mileage/ByZip',
            method: 'get',
            params: { zip, country: country || 'USA' }
        });

        const miles = res?.data?.miles;
        if (miles == null || miles === false || Number(miles) <= 0) return null;
        return String(miles);
    } catch {
        return null;
    }
}
